import platform from './node/index.js';

export {platform as default}



//////////////////
// WEBPACK FOOTER
// ./~/axios/lib/platform/index.js
// module id = ira4
// module chunks = 4